// Six creative stamps rendered inline as SVG. Small, tactile, warm.
export const STAMPS = [
  { id: "red_heart", label: "Ruby heart" },
  { id: "golden_bird", label: "Golden swallow" },
  { id: "wildflower", label: "Pressed wildflower" },
  { id: "vintage_post", label: "Vintage post" },
  { id: "moonlight", label: "Moonlight" },
  { id: "warm_sun", label: "Warm sun" },
];

const stampArt = {
  red_heart: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#F9E4D8" />
      <path d="M30 55 C 12 40 12 22 22 20 C 27 19 30 24 30 24 C 30 24 33 19 38 20 C 48 22 48 40 30 55 Z" fill="#991B1B" stroke="#7F1D1D" strokeWidth="1" />
      <text x="30" y="14" textAnchor="middle" fontSize="6" fill="#7F1D1D" fontFamily="Fraunces, serif" letterSpacing="1">LOVE</text>
      <text x="30" y="68" textAnchor="middle" fontSize="4" fill="#7F1D1D" letterSpacing="1.5">WRITTEN·HEARTS</text>
    </g>
  ),
  golden_bird: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#F5EDDD" />
      <path d="M8 40 C 18 30 28 32 34 26 C 40 20 46 22 52 30 C 46 34 40 32 34 36 C 28 40 20 42 8 40 Z" fill="#B8935A" stroke="#8b6a3a" strokeWidth="0.6" />
      <circle cx="46" cy="26" r="1.3" fill="#1C1917" />
      <path d="M20 46 Q 30 44 40 48" stroke="#B8935A" strokeWidth="0.6" fill="none" opacity="0.5" />
      <text x="30" y="64" textAnchor="middle" fontSize="5" fill="#8b6a3a" fontFamily="Fraunces, serif" fontStyle="italic">par avion</text>
    </g>
  ),
  wildflower: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#F3E7E4" />
      {[0, 60, 120, 180, 240, 300].map((a) => (
        <ellipse
          key={a}
          cx="30"
          cy="20"
          rx="4"
          ry="10"
          fill="#D97757"
          opacity="0.85"
          transform={`rotate(${a} 30 32)`}
        />
      ))}
      <circle cx="30" cy="32" r="4" fill="#B8935A" />
      <path d="M30 38 Q 28 52 26 62" stroke="#4c3f34" strokeWidth="1" fill="none" />
      <path d="M28 48 Q 32 46 34 52" stroke="#4c3f34" strokeWidth="0.8" fill="none" />
      <text x="30" y="68" textAnchor="middle" fontSize="4" fill="#4c3f34" letterSpacing="1">BLOOM</text>
    </g>
  ),
  vintage_post: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#EEE1BF" />
      <circle cx="30" cy="34" r="18" fill="none" stroke="#7F1D1D" strokeWidth="1.2" />
      <circle cx="30" cy="34" r="13" fill="none" stroke="#7F1D1D" strokeWidth="0.6" />
      <text x="30" y="30" textAnchor="middle" fontSize="6" fill="#7F1D1D" fontFamily="Fraunces, serif">POSTE</text>
      <text x="30" y="40" textAnchor="middle" fontSize="4" fill="#7F1D1D" letterSpacing="1.4">1907</text>
      <path d="M15 55 L 45 55" stroke="#7F1D1D" strokeWidth="0.6" strokeDasharray="2 2" />
      <text x="30" y="66" textAnchor="middle" fontSize="4" fill="#7F1D1D">WRITTEN·HEARTS</text>
    </g>
  ),
  moonlight: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#1E2340" />
      <circle cx="34" cy="30" r="12" fill="#F5EDDD" />
      <circle cx="30" cy="28" r="12" fill="#1E2340" />
      {[[10, 12], [50, 20], [12, 46], [48, 50], [22, 60]].map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r="0.8" fill="#F5EDDD" />
      ))}
      <text x="30" y="68" textAnchor="middle" fontSize="4" fill="#F5EDDD" letterSpacing="2">MISS·YOU</text>
    </g>
  ),
  warm_sun: (
    <g>
      <rect x="0" y="0" width="60" height="72" fill="#FBEAC5" />
      <circle cx="30" cy="32" r="9" fill="#D97706" />
      {Array.from({ length: 12 }).map((_, i) => {
        const a = (i / 12) * Math.PI * 2;
        const x1 = 30 + Math.cos(a) * 12;
        const y1 = 32 + Math.sin(a) * 12;
        const x2 = 30 + Math.cos(a) * 17;
        const y2 = 32 + Math.sin(a) * 17;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#D97706" strokeWidth="1.4" strokeLinecap="round" />;
      })}
      <text x="30" y="66" textAnchor="middle" fontSize="4" fill="#7C2D12" letterSpacing="1.5">WARMTH</text>
    </g>
  ),
};

export const Stamp = ({ id = "red_heart", size = 60, tilt = -6, className = "" }) => {
  const art = stampArt[id] || stampArt.red_heart;
  const w = size;
  const h = size * 1.2;
  return (
    <div
      className={`stamp inline-block bg-transparent ${className}`}
      style={{ width: w, height: h, transform: `rotate(${tilt}deg)` }}
    >
      <svg width={w} height={h} viewBox="0 0 60 72">
        {/* perforated frame */}
        <rect x="0" y="0" width="60" height="72" fill="#FDFBF7" />
        {art}
        {/* Perforation dots along edges */}
        {Array.from({ length: 8 }).map((_, i) => (
          <circle key={`t${i}`} cx={4 + i * 8} cy="0" r="1.6" fill="#F5EDDD" />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <circle key={`b${i}`} cx={4 + i * 8} cy="72" r="1.6" fill="#F5EDDD" />
        ))}
        {Array.from({ length: 9 }).map((_, i) => (
          <circle key={`l${i}`} cx="0" cy={4 + i * 8} r="1.6" fill="#F5EDDD" />
        ))}
        {Array.from({ length: 9 }).map((_, i) => (
          <circle key={`r${i}`} cx="60" cy={4 + i * 8} r="1.6" fill="#F5EDDD" />
        ))}
      </svg>
    </div>
  );
};

export default Stamp;
